import { parseAffiliateHandle } from 'utils/my-link-my-lead/affiliate-handle-processor';

/**
 * Removes an affiliate handle (/@handle) from a URL path.
 * Preserves query string and hash if present.
 * Returns the original path unchanged if no handle is present.
 */
export function stripAffiliateHandle(path: string): string {
  const queryIndex = path.indexOf('?');
  const hashIndex = path.indexOf('#');
  const suffixStart = queryIndex >= 0 ? queryIndex : (hashIndex >= 0 ? hashIndex : -1);
  const pathname = suffixStart >= 0 ? path.slice(0, suffixStart) : path;
  const suffix = suffixStart >= 0 ? path.slice(suffixStart) : '';

  const match = parseAffiliateHandle(pathname);
  if (!match) return path;

  const cleanPath = match.position === 'end'
    ? (match.basePath ?? '/')
    : (match.remainingPath ?? '/');

  return `${cleanPath}${suffix}`;
}
